<div class='errorMsgContainer'>
    <div class='documentWarning-icon'></div>
    <div><span class="main-msg">{{mainMessageText}}</span></div>
    <div><span class="secondary-msg">{{secondaryMessageText}}</span></div>
</div>